var map = {
	"./effect_(1).gif": "04b4",
	"./effect_(2).gif": "2fa0",
	"./effect_(3).gif": "e8ae",
	"./effect_(4).gif": "3514",
	"./effect_(5).gif": "8407",
	"./effect_(6).gif": "4f20",
	"./effect_(7).gif": "7288",
	"./effect_(8).gif": "526b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2adf6";